// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider, NotificationToast } from './context/NotificationProvider';
import DashboardLayout from './components/Layout/DashboardLayout';
import RoleBasedRoute from './components/RBAC/RoleBasedRoute';

// Pages
import Dashboard from './pages/Dashboard/Dashboard';
import Orders from './pages/Dashboard/Orders';
import Users from './pages/Dashboard/Users';
import Restaurants from './pages/Dashboard/Restaurants';
import Drivers from './components/Layout/Dashboard/Rider/Driver';
import Roles from './pages/Dashboard/Roles';
import Websetting from "./components/Layout/Dashboard/Webside/WebContent";

import Login from './pages/Login';
import AddNewRestaurant from './components/Layout/Dashboard/Restaurant/AddNewRestaurant';
import Menu from './components/Layout/Dashboard/Menu/Menu';
import ShowMenuByRestaurant from "./components/Layout/Dashboard/Menu/showmenubyrestrunt";
import RestaurantDetailPage from './components/Layout/Dashboard/Restaurant/RestaurantDetail';
import OrderDetailPage from './components/Layout/Dashboard/Orders/OrderOperationsPage';
import OrderDetail from './components/Layout/Dashboard/Orders/OrdersDetails';
import OrderTracking from './components/Layout/Dashboard/Orders/OrderTrackingModal';
import ProfileSettings from './components/Layout/Dashboard/Profile/Profile';
import RestaurantOrderHistory from './components/Layout/Dashboard/Restaurant/RestaurantOrderHistory';
import AddOffer from './components/Layout/Dashboard/Restaurant/AddOffer';

// Rider
import AddNewDriver from './components/Layout/Dashboard/Rider/AddNewRider';
import ViewmoreRider from './components/Layout/Dashboard/Rider/ViewmoreRider';

// User
import UserOrderHistory from './components/Layout/Dashboard/Users/OrderHistory';
import UserEditForm from './components/Layout/Dashboard/Users/UserEditForm';

// Location
import Location from './components/Layout/Dashboard/Restaurant/locatation';

// ==================== MAP DASHBOARD ====================
import MapDashboard from './components/Layout/Dashboard/Maps/MapDashboard';

// ==================== PAYMENTS ====================
// Withdrawal
import Withdrawal from './components/Layout/Dashboard/Payments/Withdrawal';
// Invoices
import Invoices from './components/Layout/Dashboard/Payments/Invoices';
import LockerToBank from './components/Layout/Dashboard/Payments/CashVerification/LockerToBank';
import TransitTracker from './components/Layout/Dashboard/Payments/CashVerification/BankTransitTracker';
import BankDepositHistory from './components/Layout/Dashboard/Payments/CashVerification/BankDepositHistory';
import PendingCashDeposits from './components/Layout/Dashboard/Payments/CashVerification/PendingCashDeposits';
import OnlineMoneyFlow from './components/Layout/Dashboard/Payments/OnlineMoneyFlow';

// App Support
import Banners from './components/Layout/Dashboard/AppSupport/Banners';
import Faq from './components/Layout/Dashboard/AppSupport/Faq';
import Support from './components/Layout/Dashboard/AppSupport/Support';
import Locations from './components/Layout/Dashboard/AppSupport/Locations';
import SendNotifications from './components/Layout/Dashboard/AppSupport/SendNotifications';
import Notification from './components/Layout/Dashboard/AppSupport/Notification ';
import Tickets from './components/Layout/Dashboard/AppSupport/Tickets';
import Complaints from './components/Layout/Dashboard/AppSupport/Complaints';
import CodRefundQueue from './components/Layout/Dashboard/AppSupport/CodRefundQueue';
import LiveStatus from './components/Layout/Dashboard/AppSupport/LiveStatus';
import AppSettings from './components/Layout/Dashboard/AppSupport/AppSettings';
import AppBanners from './components/Layout/Dashboard/AppSupport/AppBanners';
import RestaurantOfferBanner from './components/Layout/Dashboard/AppSupport/RestaurantOfferBanner';
import RestaurantLoginBanner from './components/Layout/Dashboard/AppSupport/RestaurantLoginBanner';

// Website
import WebBanners from './components/Layout/Dashboard/Webside/WebBanners';
import PrivacyPolicy from './components/Layout/Dashboard/Webside/privacy policy';
import TermsConditions from './components/Layout/Dashboard/Webside/Terms&conditions';
import AboutUs from './components/Layout/Dashboard/Webside/Aboutus';
import Services from './components/Layout/Dashboard/Webside/Services';
import ChooseUs from './components/Layout/Dashboard/Webside/ChooseUs';
import Enquiries from './components/Layout/Dashboard/Webside/Enquiries';
import FooterCertificates from './components/Layout/Dashboard/Webside/FooterCertificates';
import Pages from './components/Layout/Dashboard/Webside/Pages';
import CancellationPolicy from './components/Layout/Dashboard/Webside/cancellationpolicy';
import RefundPolicy from './components/Layout/Dashboard/Webside/Refundpolicy';
import PressRelease from './components/Layout/Dashboard/Webside/pressrelase';

// Config
import DeliveryFare from './components/Layout/Dashboard/Config/DeliveryFare';
import PlatformFee from './components/Layout/Dashboard/Config/platformfee';
import MOUpages from './components/Layout/Dashboard/Config/mouagreements';

// Reports
import ViewReports from './components/Layout/Dashboard/Reports/Reports';
import DevFeedback from './components/Layout/Dashboard/DevFeedback/DevFeedback'

// Settings
import Regions from './components/Layout/Dashboard/Maps/Regions';
import Staff from './components/Layout/Dashboard/staff';
import RolesSettings from './components/Layout/Dashboard/Roles';
import GeneralSettings from './components/Layout/Dashboard/GeneralSettings';

// Official Member
import OfficialMember from './components/Layout/Dashboard/OfficialMember/OfficialMember';
import OfficialMemberDetail from './components/Layout/Dashboard/OfficialMember/OfficialMemberDetail';

import CashDashboard from './components/Layout/Dashboard/Rider/CashDashboard';
import VerifiedCashDeposits from './components/Layout/Dashboard/Payments/CashVerification/VerifiedCashDeposits';
import CashMoney from './pages/Dashboard/CashMoney';

// Notification Component
import ShowNotification from './components/Layout/Dashboard/Profile/Shownotify';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <NotificationProvider>
            <NotificationToast />
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route element={<DashboardLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                
                {/* ==================== MAP DASHBOARD ==================== */}
                <Route 
                  path="/dashboard/map" 
                  element={
                    <RoleBasedRoute permission="app_support.map">
                      <MapDashboard />
                    </RoleBasedRoute>
                  } 
                />
                
                {/* ==================== ORDERS ==================== */}
                <Route path="/dashboard/orders" element={<RoleBasedRoute permission="orders.view"><Orders /></RoleBasedRoute>} />
                <Route path="/dashboard/orders/detail" element={<RoleBasedRoute permission="orders.view"><OrderDetail /></RoleBasedRoute>} />
                <Route path="/dashboard/order-detail" element={<RoleBasedRoute permission="orders.view"><OrderDetailPage /></RoleBasedRoute>} />
                <Route path="/dashboard/order-tracking" element={<RoleBasedRoute permission="orders.order_tracking_model"><OrderTracking /></RoleBasedRoute>} />
                
                {/* ==================== USERS ==================== */}
                <Route path="/dashboard/users" element={<RoleBasedRoute permission="users.view"><Users /></RoleBasedRoute>} />
                <Route path="/dashboard/users/order-history" element={<RoleBasedRoute permission="users.OrderHistory"><UserOrderHistory /></RoleBasedRoute>} />
                <Route path="/dashboard/users/edit" element={<RoleBasedRoute permission="users.edit"><UserEditForm /></RoleBasedRoute>} />
                
                {/* ==================== RESTAURANTS ==================== */}
                <Route path="/dashboard/restaurants" element={<RoleBasedRoute permission="restaurants.overview"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/overview" element={<RoleBasedRoute permission="restaurants.overview"><Restaurants /></RoleBasedRoute>} />
                
                {/* ✅ Added route for showmenubyResturent with permission "restaurants.menu" */}
                <Route
                  path="/dashboard/restaurants/menubyresturent"
                  element={
                    <RoleBasedRoute permission="restaurants.menu">
                      <ShowMenuByRestaurant />
                    </RoleBasedRoute>
                  }
                />
                <Route path="/dashboard/restaurants/menu" element={<RoleBasedRoute permission="restaurants.menu"><Menu /></RoleBasedRoute>} />
                
                <Route path="/dashboard/restaurants/orders" element={<RoleBasedRoute permission="restaurants.orders"><RestaurantOrderHistory /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/timings" element={<RoleBasedRoute permission="restaurants.timings"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/payments" element={<RoleBasedRoute permission="restaurants.payments"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/reviews" element={<RoleBasedRoute permission="restaurants.reviews"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/location" element={<RoleBasedRoute permission="restaurants.location"><Location /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/documents" element={<RoleBasedRoute permission="restaurants.documents"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/active-offers" element={<RoleBasedRoute permission="restaurants.active_offers"><Restaurants /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/offers" element={<RoleBasedRoute permission="restaurants.active_offers"><AddOffer /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/detail" element={<RoleBasedRoute permission="restaurants.overview"><RestaurantDetailPage /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/create" element={<RoleBasedRoute permission="restaurants.create"><AddNewRestaurant /></RoleBasedRoute>} />
                <Route path="/dashboard/restaurants/edit" element={<RoleBasedRoute permission="restaurants.edit"><AddNewRestaurant /></RoleBasedRoute>} />
                <Route path="/Dashboard/editrestaurant" element={<RoleBasedRoute permission="restaurants.edit"><AddNewRestaurant /></RoleBasedRoute>} />
                
                {/* ==================== DISHES ==================== */}
                <Route path="/dashboard/dishes" element={<RoleBasedRoute permission="dishes.menu"><Menu /></RoleBasedRoute>} />
                <Route path="/dashboard/dishes/menu" element={<RoleBasedRoute permission="dishes.menu"><Menu /></RoleBasedRoute>} />
                
                {/* ==================== DRIVERS ==================== */}
                <Route path="/dashboard/drivers" element={<RoleBasedRoute permission="drivers.overview"><Drivers /></RoleBasedRoute>} />
                <Route path="/dashboard/drivers/ViewmoreRider" element={<RoleBasedRoute permission="drivers.overview"><ViewmoreRider /></RoleBasedRoute>} />
                <Route path="/dashboard/drivers/cash-dashboard" element={<RoleBasedRoute permission="drivers.cash_dashboard"><CashDashboard /></RoleBasedRoute>} />
                <Route path="/dashboard/drivers/create" element={<RoleBasedRoute permission="drivers.create"><AddNewDriver /></RoleBasedRoute>} />
                <Route path="/dashboard/drivers/Edit" element={<RoleBasedRoute permission="drivers.edit_driver"><AddNewDriver /></RoleBasedRoute>} />
                <Route path="/dashboard/drivers/view" element={<RoleBasedRoute permission="drivers.overview"><ViewmoreRider /></RoleBasedRoute>} />
                
                {/* ==================== PAYMENTS ==================== */}
                <Route path="/dashboard/payments" element={<RoleBasedRoute permission="payments"><Navigate to="/dashboard/payments/withdrawal" replace /></RoleBasedRoute>} />
                
                {/* Withdrawal */}
                <Route path="/dashboard/payments/withdrawal" element={<RoleBasedRoute permission="payments.withdrawal"><Withdrawal /></RoleBasedRoute>} />
                <Route path="/dashboard/payments/online-money" element={<RoleBasedRoute permission="payments"><OnlineMoneyFlow /></RoleBasedRoute>} />
                
                {/* Invoices */}
                <Route path="/dashboard/payments/invoices" element={<RoleBasedRoute permission="payments.invoices"><Invoices /></RoleBasedRoute>} />
                
                {/* Cash Verification - All sub-pages */}
                <Route path="/dashboard/payments/cash-verification" element={<Navigate to="/dashboard/payments/cash-verification/pending" replace />} />
                <Route
                  path="/dashboard/payments/cash-verification/verified"
                  element={
                    <RoleBasedRoute permission="payments.Verified History">
                      <VerifiedCashDeposits />
                    </RoleBasedRoute>
                  }
                />
                <Route path="/dashboard/payments/cash-verification/pending" element={<RoleBasedRoute permission="payments.Cash Verification"><PendingCashDeposits /></RoleBasedRoute>} />
                <Route path="/dashboard/payments/cash-verification/history" element={<Navigate to="/dashboard/payments/bank-history" replace />} />
                
                {/* Locker to Bank */}
                <Route path="/dashboard/payments/locker-to-bank" element={<RoleBasedRoute permission="payments.Locker to Bank"><LockerToBank /></RoleBasedRoute>} />
                
                {/* Transit Tracker */}
                <Route path="/dashboard/payments/transit-tracker" element={<RoleBasedRoute permission="payments.Transit Tracker"><TransitTracker /></RoleBasedRoute>} />
                
                {/* Verified cash collected from riders */}
                <Route path="/dashboard/payments/verified-history" element={<Navigate to="/dashboard/payments/cash-verification/verified" replace />} />

                {/* Final bank deposit history */}
                <Route path="/dashboard/payments/bank-history" element={<RoleBasedRoute permission={['payments.Bank History', 'payments.Verified History']}><BankDepositHistory /></RoleBasedRoute>} />

                {/* ==================== CASHMONEY - COD Tracker ==================== */}
                <Route path="/dashboard/payments/cashmoney" element={<RoleBasedRoute permission="payments"><CashMoney /></RoleBasedRoute>} />
                
                {/* ==================== APP SUPPORT ==================== */}
                <Route path="/dashboard/app-support" element={<RoleBasedRoute permission="app_support"><Navigate to="/dashboard/app-support/map" replace /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/support" element={<RoleBasedRoute permission="app_support.support"><Support /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/settings" element={<RoleBasedRoute permission="app_support.app_settings"><AppSettings /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/app-banners" element={<RoleBasedRoute permission="app_support.banners"><AppBanners /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/restaurant-offer-banner" element={<RoleBasedRoute permission="app_support.restaurant_offer_banner"><RestaurantOfferBanner /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/restaurant-login-banner" element={<RoleBasedRoute permission="app_support.restaurant_login_banner"><RestaurantLoginBanner /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/tickets" element={<RoleBasedRoute permission="app_support.tickets"><Tickets /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/complaints" element={<RoleBasedRoute permission="app_support.tickets"><Complaints /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/cod-refunds" element={<RoleBasedRoute permission="app_support.tickets"><CodRefundQueue /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/notifications" element={<RoleBasedRoute permission="app_support.notifications"><Notification /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/send-notifications" element={<RoleBasedRoute permission="app_support.send_notifications"><SendNotifications /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/live-status" element={<RoleBasedRoute permission="app_support.live_status"><LiveStatus /></RoleBasedRoute>} />
                <Route path="/dashboard/app-support/faq" element={<RoleBasedRoute permission="app_support.faq"><Faq /></RoleBasedRoute>} />
                
                {/* ==================== WEBSITE ==================== */}
                <Route path="/dashboard/website" element={<RoleBasedRoute permission="website.website"><Navigate to="/dashboard/website/banners" replace /></RoleBasedRoute>} />
                <Route path="/dashboard/website/banners" element={<RoleBasedRoute permission="website.web_banners"><WebBanners /></RoleBasedRoute>} />
                <Route path="/dashboard/website/pages" element={<RoleBasedRoute permission="website.pages"><Pages /></RoleBasedRoute>} />
                <Route path="/dashboard/website/privacy-policy" element={<RoleBasedRoute permission="website.privacy_policy"><PrivacyPolicy /></RoleBasedRoute>} />
                <Route path="/dashboard/website/terms-conditions" element={<RoleBasedRoute permission="website.terms_conditions"><TermsConditions /></RoleBasedRoute>} />
                <Route path="/dashboard/website/about-us" element={<RoleBasedRoute permission="website.about_us"><AboutUs /></RoleBasedRoute>} />
                <Route path="/dashboard/website/cancellation-policy" element={<RoleBasedRoute permission="website.cancellation_policy"><CancellationPolicy /></RoleBasedRoute>} />
                <Route path="/dashboard/website/refund-policy" element={<RoleBasedRoute permission="website.refund_policy"><RefundPolicy /></RoleBasedRoute>} />
                <Route path="/dashboard/website/services" element={<RoleBasedRoute permission="website.services"><Services /></RoleBasedRoute>} />
                <Route path="/dashboard/website/choose-us" element={<RoleBasedRoute permission="website.choose_us"><ChooseUs /></RoleBasedRoute>} />
                <Route path="/dashboard/website/press-release" element={<RoleBasedRoute permission="website.press_release"><PressRelease /></RoleBasedRoute>} />
                <Route path="/dashboard/website/enquiries" element={<RoleBasedRoute permission="website.enquiries"><Enquiries /></RoleBasedRoute>} />
                <Route path="/dashboard/website/footer-certificates" element={<RoleBasedRoute permission="website.footer_certificates"><FooterCertificates /></RoleBasedRoute>} />
                
                {/* ✅ WEBSITE - WEB SETTING ROUTE (FIXED) */}
                <Route 
                  path="/dashboard/website/web-setting" 
                  element={
                    <RoleBasedRoute permission="website.web_setting">
                      <Websetting />
                    </RoleBasedRoute>
                  } 
                />
                
                {/* ==================== CONFIG ==================== */}
                <Route path="/dashboard/config" element={<RoleBasedRoute permission="config"><Navigate to="/dashboard/config/delivery-fare" replace /></RoleBasedRoute>} />
                <Route path="/dashboard/config/delivery-fare" element={<RoleBasedRoute permission="config.delivery_fare"><DeliveryFare /></RoleBasedRoute>} />
                <Route path="/dashboard/config/platform-fee" element={<RoleBasedRoute permission="config.platform_fee"><PlatformFee /></RoleBasedRoute>} />
                <Route path="/dashboard/config/application-pages" element={<RoleBasedRoute permission="config.application_pages"><MOUpages /></RoleBasedRoute>} />
                
                {/* ==================== REPORTS ==================== */}
                <Route path="/dashboard/reports" element={<RoleBasedRoute permission="reports"><Navigate to="/dashboard/reports/view" replace /></RoleBasedRoute>} />
                <Route path="/dashboard/reports/view" element={<RoleBasedRoute permission="reports.view"><ViewReports /></RoleBasedRoute>} />
                
                {/* ==================== DEV FEEDBACK ==================== */}
                <Route path="/dashboard/dev-feedback" element={<RoleBasedRoute permission="dev_feedback.dev_feedback"><DevFeedback /></RoleBasedRoute>} />
                
                {/* ==================== SETTINGS ==================== */}
                <Route path="/dashboard/settings" element={<RoleBasedRoute permission="settings"><Navigate to="/dashboard/settings/regions" replace /></RoleBasedRoute>} />
                <Route path="/dashboard/settings/regions" element={<RoleBasedRoute permission="settings.regions"><Regions /></RoleBasedRoute>} />
                <Route path="/dashboard/settings/staff" element={<RoleBasedRoute permission="settings.staff"><Staff /></RoleBasedRoute>} />
                <Route path="/dashboard/settings/roles" element={<RoleBasedRoute permission="settings.roles"><RolesSettings /></RoleBasedRoute>} />
                <Route path="/dashboard/settings/general" element={<RoleBasedRoute permission="settings.general"><GeneralSettings /></RoleBasedRoute>} />

                {/* ==================== PROFILE - NO permission required ==================== */}
                <Route path="/dashboard/profile" element={<ProfileSettings />} />

                {/* ==================== OFFICIAL MEMBER - NO permission required ==================== */}
                <Route path="/dashboard/official-member" element={<OfficialMember />} />
                <Route path="/dashboard/official-member/:id" element={<OfficialMemberDetail />} />

                {/* ==================== SHOW NOTIFICATION ROUTE ==================== */}
                <Route path="/dashboard/show-notification" element={<ShowNotification />} />
              </Route>
              
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </NotificationProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
